import React, { useEffect, useState, useContext, useRef } from "react";
import "@dotlottie/player-component";
import AnimatedCursor from "react-animated-cursor";
import { useNavigate } from "react-router-dom"; // 
import { isMobile } from "detect-touch-device";
/* plugin */
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, EffectFade, Navigation, Autoplay, Controller, Pagination } from "swiper/modules";
/* plugin end */
import { Link } from "react-router-dom";
import gs from "../../../service/global";
import mainContext from "../../../config/mainContext";
const { REACT_APP_ASSET_URL } = process.env;

function callWebengageTrackEvent(event_name) {
  window.webengage.track(event_name, {});
}

const faqsQus = [
  {
    question:
      "Is my money secure?",
    answer:
      "Held with Emirates NBD under DFSA client money rules.",
  },
  {
    question: "What returns can I expect?",
    answer:
      "Possible dividends + capital gains, not guaranteed.",
  },
  {
    question: "What if operations cease?",
    answer:
      "Investments remain protected in SPVs with licensed management transfer.",
  },
  {
    question: "Investment limits and fees?",
    answer: (
      <>
        <p>
          <strong>Retail Investors:</strong> Up to <strong>$100,000/year;</strong> max <strong>$50,000</strong> per property.
        </p>
        <p>
          <strong>Professional Investors:</strong> No cap (DFSA classification).
        </p>
        <p>
          <strong>Fee:</strong> 1.5% onboarding · 1% annual admin · 2.5% exit
        </p>
      </>
    )
  }
];

const countryCodes = [
  { "name": "Afghanistan", "code": "AF", "phone": "+93" },
  { "name": "Albania", "code": "AL", "phone": "+355" },
  { "name": "Algeria", "code": "DZ", "phone": "+213" },
  { "name": "American Samoa", "code": "AS", "phone": "+1684" },
  { "name": "Andorra", "code": "AD", "phone": "+376" },
  { "name": "Angola", "code": "AO", "phone": "+244" },
  { "name": "Anguilla", "code": "AI", "phone": "+1264" },
  { "name": "Antarctica", "code": "AQ", "phone": "+672" },
  { "name": "Antigua and Barbuda", "code": "AG", "phone": "+1268" },
  { "name": "Argentina", "code": "AR", "phone": "+54" },
  { "name": "Armenia", "code": "AM", "phone": "+374" },
  { "name": "Aruba", "code": "AW", "phone": "+297" },
  { "name": "Australia", "code": "AU", "phone": "+61" },
  { "name": "Austria", "code": "AT", "phone": "+43" },
  { "name": "Azerbaijan", "code": "AZ", "phone": "+994" },
  { "name": "Bahamas", "code": "BS", "phone": "+1242" },
  { "name": "Bahrain", "code": "BH", "phone": "+973" },
  { "name": "Bangladesh", "code": "BD", "phone": "+880" },
  { "name": "Barbados", "code": "BB", "phone": "+1246" },
  { "name": "Belarus", "code": "BY", "phone": "+375" },
  { "name": "Belgium", "code": "BE", "phone": "+32" },
  { "name": "Belize", "code": "BZ", "phone": "+501" },
  { "name": "Benin", "code": "BJ", "phone": "+229" },
  { "name": "Bermuda", "code": "BM", "phone": "+1441" },
  { "name": "Bhutan", "code": "BT", "phone": "+975" },
  { "name": "Bolivia", "code": "BO", "phone": "+591" },
  { "name": "Bosnia and Herzegovina", "code": "BA", "phone": "+387" },
  { "name": "Botswana", "code": "BW", "phone": "+267" },
  { "name": "Brazil", "code": "BR", "phone": "+55" },
  { "name": "British Indian Ocean Territory", "code": "IO", "phone": "+246" },
  { "name": "Brunei", "code": "BN", "phone": "+673" },
  { "name": "Bulgaria", "code": "BG", "phone": "+359" },
  { "name": "Burkina Faso", "code": "BF", "phone": "+226" },
  { "name": "Burundi", "code": "BI", "phone": "+257" },
  { "name": "Cambodia", "code": "KH", "phone": "+855" },
  { "name": "Cameroon", "code": "CM", "phone": "+237" },
  { "name": "Canada", "code": "CA", "phone": "+1" },
  { "name": "Cape Verde", "code": "CV", "phone": "+238" },
  { "name": "Cayman Islands", "code": "KY", "phone": "+1345" },
  { "name": "Central African Republic", "code": "CF", "phone": "+236" },
  { "name": "Chad", "code": "TD", "phone": "+235" },
  { "name": "Chile", "code": "CL", "phone": "+56" },
  { "name": "China", "code": "CN", "phone": "+86" },
  { "name": "Christmas Island", "code": "CX", "phone": "+61" },
  { "name": "Cocos Islands", "code": "CC", "phone": "+61" },
  { "name": "Colombia", "code": "CO", "phone": "+57" },
  { "name": "Comoros", "code": "KM", "phone": "+269" },
  { "name": "Congo", "code": "CG", "phone": "+242" },
  { "name": "Cook Islands", "code": "CK", "phone": "+682" },
  { "name": "Costa Rica", "code": "CR", "phone": "+506" },
  { "name": "Croatia", "code": "HR", "phone": "+385" },
  { "name": "Cuba", "code": "CU", "phone": "+53" },
  { "name": "Cyprus", "code": "CY", "phone": "+357" },
  { "name": "Czech Republic", "code": "CZ", "phone": "+420" },
  { "name": "Denmark", "code": "DK", "phone": "+45" },
  { "name": "Djibouti", "code": "DJ", "phone": "+253" },
  { "name": "Dominica", "code": "DM", "phone": "+1767" },
  { "name": "Dominican Republic", "code": "DO", "phone": "+1" },
  { "name": "Ecuador", "code": "EC", "phone": "+593" },
  { "name": "Egypt", "code": "EG", "phone": "+20" },
  { "name": "El Salvador", "code": "SV", "phone": "+503" },
  { "name": "Equatorial Guinea", "code": "GQ", "phone": "+240" },
  { "name": "Eritrea", "code": "ER", "phone": "+291" },
  { "name": "Estonia", "code": "EE", "phone": "+372" },
  { "name": "Eswatini", "code": "SZ", "phone": "+268" },
  { "name": "Ethiopia", "code": "ET", "phone": "+251" },
  { "name": "Fiji", "code": "FJ", "phone": "+679" },
  { "name": "Finland", "code": "FI", "phone": "+358" },
  { "name": "France", "code": "FR", "phone": "+33" },
  { "name": "French Polynesia", "code": "PF", "phone": "+689" },
  { "name": "Gabon", "code": "GA", "phone": "+241" },
  { "name": "Gambia", "code": "GM", "phone": "+220" },
  { "name": "Georgia", "code": "GE", "phone": "+995" },
  { "name": "Germany", "code": "DE", "phone": "+49" },
  { "name": "Ghana", "code": "GH", "phone": "+233" },
  { "name": "Gibraltar", "code": "GI", "phone": "+350" },
  { "name": "Greece", "code": "GR", "phone": "+30" },
  { "name": "Greenland", "code": "GL", "phone": "+299" },
  { "name": "Grenada", "code": "GD", "phone": "+1473" },
  { "name": "Guam", "code": "GU", "phone": "+1671" },
  { "name": "Guatemala", "code": "GT", "phone": "+502" },
  { "name": "Guernsey", "code": "GG", "phone": "+44" },
  { "name": "Guinea", "code": "GN", "phone": "+224" },
  { "name": "Guinea-Bissau", "code": "GW", "phone": "+245" },
  { "name": "Guyana", "code": "GY", "phone": "+592" },
  { "name": "Haiti", "code": "HT", "phone": "+509" },
  { "name": "Honduras", "code": "HN", "phone": "+504" },
  { "name": "Hong Kong", "code": "HK", "phone": "+852" },
  { "name": "Hungary", "code": "HU", "phone": "+36" },
  { "name": "Iceland", "code": "IS", "phone": "+354" },
  { "name": "India", "code": "IN", "phone": "+91" },
  { "name": "Indonesia", "code": "ID", "phone": "+62" },
  { "name": "Iran", "code": "IR", "phone": "+98" },
  { "name": "Iraq", "code": "IQ", "phone": "+964" },
  { "name": "Ireland", "code": "IE", "phone": "+353" },
  { "name": "Isle of Man", "code": "IM", "phone": "+44" },
  { "name": "Israel", "code": "IL", "phone": "+972" },
  { "name": "Italy", "code": "IT", "phone": "+39" },
  { "name": "Jamaica", "code": "JM", "phone": "+1876" },
  { "name": "Japan", "code": "JP", "phone": "+81" },
  { "name": "Jersey", "code": "JE", "phone": "+44" },
  { "name": "Jordan", "code": "JO", "phone": "+962" },
  { "name": "Kazakhstan", "code": "KZ", "phone": "+7" },
  { "name": "Kenya", "code": "KE", "phone": "+254" },
  { "name": "Kiribati", "code": "KI", "phone": "+686" },
  { "name": "Kuwait", "code": "KW", "phone": "+965" },
  { "name": "Kyrgyzstan", "code": "KG", "phone": "+996" },
  { "name": "Laos", "code": "LA", "phone": "+856" },
  { "name": "Latvia", "code": "LV", "phone": "+371" },
  { "name": "Lebanon", "code": "LB", "phone": "+961" },
  { "name": "Lesotho", "code": "LS", "phone": "+266" },
  { "name": "Liberia", "code": "LR", "phone": "+231" },
  { "name": "Libya", "code": "LY", "phone": "+218" },
  { "name": "Liechtenstein", "code": "LI", "phone": "+423" },
  { "name": "Lithuania", "code": "LT", "phone": "+370" },
  { "name": "Luxembourg", "code": "LU", "phone": "+352" },
  { "name": "Macao", "code": "MO", "phone": "+853" },
  { "name": "Madagascar", "code": "MG", "phone": "+261" },
  { "name": "Malawi", "code": "MW", "phone": "+265" },
  { "name": "Malaysia", "code": "MY", "phone": "+60" },
  { "name": "Maldives", "code": "MV", "phone": "+960" },
  { "name": "Mali", "code": "ML", "phone": "+223" },
  { "name": "Malta", "code": "MT", "phone": "+356" },
  { "name": "Marshall Islands", "code": "MH", "phone": "+692" },
  { "name": "Martinique", "code": "MQ", "phone": "+596" },
  { "name": "Mauritania", "code": "MR", "phone": "+222" },
  { "name": "Mauritius", "code": "MU", "phone": "+230" },
  { "name": "Mayotte", "code": "YT", "phone": "+262" },
  { "name": "Mexico", "code": "MX", "phone": "+52" },
  { "name": "Micronesia", "code": "FM", "phone": "+691" },
  { "name": "Moldova", "code": "MD", "phone": "+373" },
  { "name": "Monaco", "code": "MC", "phone": "+377" },
  { "name": "Mongolia", "code": "MN", "phone": "+976" },
  { "name": "Montenegro", "code": "ME", "phone": "+382" },
  { "name": "Montserrat", "code": "MS", "phone": "+1664" },
  { "name": "Morocco", "code": "MA", "phone": "+212" },
  { "name": "Mozambique", "code": "MZ", "phone": "+258" },
  { "name": "Myanmar", "code": "MM", "phone": "+95" },
  { "name": "Namibia", "code": "NA", "phone": "+264" },
  { "name": "Nauru", "code": "NR", "phone": "+674" },
  { "name": "Nepal", "code": "NP", "phone": "+977" },
  { "name": "Netherlands", "code": "NL", "phone": "+31" },
  { "name": "New Zealand", "code": "NZ", "phone": "+64" },
  { "name": "Nicaragua", "code": "NI", "phone": "+505" },
  { "name": "Niger", "code": "NE", "phone": "+227" },
  { "name": "Nigeria", "code": "NG", "phone": "+234" },
  { "name": "Niue", "code": "NU", "phone": "+683" },
  { "name": "North Korea", "code": "KP", "phone": "+850" },
  { "name": "North Macedonia", "code": "MK", "phone": "+389" },
  { "name": "Norway", "code": "NO", "phone": "+47" },
  { "name": "Oman", "code": "OM", "phone": "+968" },
  { "name": "Pakistan", "code": "PK", "phone": "+92" },
  { "name": "Palau", "code": "PW", "phone": "+680" },
  { "name": "Panama", "code": "PA", "phone": "+507" },
  { "name": "Papua New Guinea", "code": "PG", "phone": "+675" },
  { "name": "Paraguay", "code": "PY", "phone": "+595" },
  { "name": "Peru", "code": "PE", "phone": "+51" },
  { "name": "Philippines", "code": "PH", "phone": "+63" },
  { "name": "Poland", "code": "PL", "phone": "+48" },
  { "name": "Portugal", "code": "PT", "phone": "+351" },
  { "name": "Puerto Rico", "code": "PR", "phone": "+1" },
  { "name": "Qatar", "code": "QA", "phone": "+974" },
  { "name": "Reunion", "code": "RE", "phone": "+262" },
  { "name": "Romania", "code": "RO", "phone": "+40" },
  { "name": "Russia", "code": "RU", "phone": "+7" },
  { "name": "Rwanda", "code": "RW", "phone": "+250" },
  { "name": "Saint Kitts and Nevis", "code": "KN", "phone": "+1869" },
  { "name": "Saint Lucia", "code": "LC", "phone": "+1758" },
  { "name": "Saint Vincent and the Grenadines", "code": "VC", "phone": "+1784" },
  { "name": "Samoa", "code": "WS", "phone": "+685" },
  { "name": "San Marino", "code": "SM", "phone": "+378" },
  { "name": "Saudi Arabia", "code": "SA", "phone": "+966" },
  { "name": "Senegal", "code": "SN", "phone": "+221" },
  { "name": "Serbia", "code": "RS", "phone": "+381" },
  { "name": "Seychelles", "code": "SC", "phone": "+248" },
  { "name": "Sierra Leone", "code": "SL", "phone": "+232" },
  { "name": "Singapore", "code": "SG", "phone": "+65" },
  { "name": "Slovakia", "code": "SK", "phone": "+421" },
  { "name": "Slovenia", "code": "SI", "phone": "+386" },
  { "name": "Solomon Islands", "code": "SB", "phone": "+677" },
  { "name": "Somalia", "code": "SO", "phone": "+252" },
  { "name": "South Africa", "code": "ZA", "phone": "+27" },
  { "name": "South Korea", "code": "KR", "phone": "+82" },
  { "name": "South Sudan", "code": "SS", "phone": "+211" },
  { "name": "Spain", "code": "ES", "phone": "+34" },
  { "name": "Sri Lanka", "code": "LK", "phone": "+94" },
  { "name": "Sudan", "code": "SD", "phone": "+249" },
  { "name": "Suriname", "code": "SR", "phone": "+597" },
  { "name": "Sweden", "code": "SE", "phone": "+46" },
  { "name": "Switzerland", "code": "CH", "phone": "+41" },
  { "name": "Syria", "code": "SY", "phone": "+963" },
  { "name": "Taiwan", "code": "TW", "phone": "+886" },
  { "name": "Tajikistan", "code": "TJ", "phone": "+992" },
  { "name": "Tanzania", "code": "TZ", "phone": "+255" },
  { "name": "Thailand", "code": "TH", "phone": "+66" },
  { "name": "Timor-Leste", "code": "TL", "phone": "+670" },
  { "name": "Togo", "code": "TG", "phone": "+228" },
  { "name": "Tokelau", "code": "TK", "phone": "+690" },
  { "name": "Tonga", "code": "TO", "phone": "+676" },
  { "name": "Trinidad and Tobago", "code": "TT", "phone": "+1868" },
  { "name": "Tunisia", "code": "TN", "phone": "+216" },
  { "name": "Turkey", "code": "TR", "phone": "+90" },
  { "name": "Turkmenistan", "code": "TM", "phone": "+993" },
  { "name": "Tuvalu", "code": "TV", "phone": "+688" },
  { "name": "Uganda", "code": "UG", "phone": "+256" },
  { "name": "Ukraine", "code": "UA", "phone": "+380" },
  { "name": "United Arab Emirates", "code": "AE", "phone": "+971" },
  { "name": "United Kingdom", "code": "GB", "phone": "+44" },
  { "name": "United States", "code": "US", "phone": "+1" },
  { "name": "Uruguay", "code": "UY", "phone": "+598" },
  { "name": "Uzbekistan", "code": "UZ", "phone": "+998" },
  { "name": "Vanuatu", "code": "VU", "phone": "+678" },
  { "name": "Vatican City", "code": "VA", "phone": "+379" },
  { "name": "Venezuela", "code": "VE", "phone": "+58" },
  { "name": "Vietnam", "code": "VN", "phone": "+84" },
  { "name": "Yemen", "code": "YE", "phone": "+967" },
  { "name": "Zambia", "code": "ZM", "phone": "+260" },
  { "name": "Zimbabwe", "code": "ZW", "phone": "+263" }
];

/* click cta event */
const gtagEvent = (label) => {
  if (window.gtag) {
    // alert(label);
    window.gtag("event", label, {
      event_category: "CTA",
      event_label: label,
    });
  }
};

function menuClick() {
  document.querySelector(".mobile-menu").classList.add("in");
  document.querySelector(".menuOverlay").classList.add("in");
  document.querySelector("body").classList.add("overflow-hidden");
}

function closeClick() {
  document.querySelector(".menuOverlay").classList.remove("in");
  document.querySelector(".mobile-menu").classList.remove("in");
  document.querySelector("body").classList.remove("overflow-hidden");
}
const features = [
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_model.svg`,
    title: "Fractionalisation Model",
    desc: "Multiple investors pool funds to participate in prime real estate.",
  },
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_svp.svg`,
    title: "SPV Ownership",
    desc: "Each property is held in a regulated Special Purpose Vehicle, ensuring investor rights.",
  },
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_protection.svg`,
    title: "Legal Protection",
    desc: "SPV structure shields investors from Slice’s business risks and liabilities.",
  },
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_transparency.svg`,
    title: "Transparency",
    desc: "Full due diligence, valuation reports, and regulated compliance under DFSA.",
  },
];

const steps = [
  {

    img: `${process.env.REACT_APP_ASSET_URL}/lp/container.svg`,
    title: "Create your account",
    desc: "Setting up a Slice account is a simple 3 step sign-up process",
  },
  {

    img: `${process.env.REACT_APP_ASSET_URL}/lp/container2.svg`,
    title: "Browse Properties",
    desc: "Discover expert-curated real estate opportunities, complete with due diligence reports, amenities, projected returns, and transparent fee details.",
  },
  {

    img: `${process.env.REACT_APP_ASSET_URL}/lp/container3.svg`,
    title: "Invest and earn returns",
    desc: "Choose your property, invest securely, and let your money work for you. Track dividends and potential appreciation directly from your Slice dashboard.",
  },
];

const LPv3 = () => {
  const [firstClientSwiper, setFirstClientSwiper] = useState(null);
  const [secondClientSwiper, setSecondClientSwiper] = useState(null);
  const navigate = useNavigate();
  const mainObj = useContext(mainContext);
  const [activeId, setActiveId] = useState("");
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [passwordRules, setPasswordRules] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, password: value });

    setPasswordRules({
      length: value.length >= 8 && value.length <= 64,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /[0-9]/.test(value),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(value),
    });
  };


  const [popuperrors, setErrorsPopup] = useState({
    firstNamePopup: "",
    lastNamePopup: "",
    emailPopup: "",
    mobilePopup: "",
  });
  const validateForm = () => {
    let valid = true;
    let newErrors = { firstName: "", lastName: "", email: "", mobile: "" };

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      valid = false;
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
      valid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
      valid = false;
    }
    if (formData.mobile.trim()) {
      if (!/^[0-9]+$/.test(formData.mobile)) {
        newErrors.mobile = "Only digits are allowed";
        valid = false;
      }
    }
    // Password validation
    if (
      !formData.password ||
      !(
        passwordRules.length &&
        passwordRules.uppercase &&
        passwordRules.lowercase &&
        passwordRules.number &&
        passwordRules.special
      )
    ) {
      newErrors.password =
        "Password must be 8–64 characters and include uppercase, lowercase, number, and special character.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };
  const validateFormPopup = () => {
    let valid = true;
    let newErrors = { firstNamePopup: "", lastNamePopup: "", emailPopup: "", mobilePopup: "" };

    if (!formDataPopup.firstNamePopup.trim()) {
      newErrors.firstNamePopup = "First name is required";
      valid = false;
    }

    if (!formDataPopup.lastNamePopup.trim()) {
      newErrors.lastNamePopup = "Last name is required";
      valid = false;
    }

    if (!formDataPopup.emailPopup.trim()) {
      newErrors.emailPopup = "Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formDataPopup.emailPopup)) {
      newErrors.emailPopup = "Email is invalid";
      valid = false;
    }
    if (formDataPopup.mobilePopup.trim()) {
      if (!/^[0-9]+$/.test(formDataPopup.mobilePopup)) {
        newErrors.mobilePopup = "Only digits are allowed";
        valid = false;
      }
    }
    setErrorsPopup(newErrors);
    return valid;
  };

  useEffect(() => {
      fetch("https://ipapi.co/json/")
        .then(res => res.json())
        .then(data => {
          const match = countryCodes.find(c => c.code === data.country);
          if (match) {
            setFormData(prev => ({
              ...prev,
              countryCode: match.phone,   // store selected country code
            }));
            setFormDataPopup(prev => ({
              ...prev,
              countryCodePopup: match.phone,   // store selected country code
            }));
          }
        })
        .catch(err => console.log("IP API error:", err));
    }, []);
    const handleCountryChange = (e) => {
      const selectedCode = e.target.value;
  
      setFormData(prev => ({
        ...prev,
        countryCode: selectedCode,
      }));
      setFormDataPopup(prev => ({
        ...prev,
        countryCodePopup: selectedCode,   // store selected country code
      }));
    };
    const getFlag = (isoCode) => {
      return isoCode
        .toUpperCase()
        .replace(/./g, char =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        );
    };

  useEffect(() => {

    /* Loader Starts */
    gs.showLoader(true);
    /* Loader Ends */

    // Hotjar Tracking Code
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 6527090, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");


    const sections = document.querySelectorAll("section[id]");
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries.filter((e) => e.isIntersecting);
        if (visibleEntries.length > 0) {
          const mostVisible = visibleEntries.reduce((a, b) =>
            a.intersectionRatio > b.intersectionRatio ? a : b
          );
          setActiveId(mostVisible.target.id);
        }
      },
      { threshold: [0.5, 0.75, 1] }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);
  /* slider code */
  const handleSlideChange = (swiper) => {
    // console.log(swiper.activeIndex);
    const gridList = document.querySelectorAll(".comm-slide-list li");
    gridList.forEach((para) => para.classList.remove("active"));
    document.querySelector(`.st-${swiper.activeIndex}`).classList.add("active");
  };
  // Smooth scroll with header offset
  const handleScroll = (e, id) => {
    e.preventDefault();
    const target = document.getElementById(id);
    const headerOffset = 80; // adjust to your header height
    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  const handleLinkClick = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  };
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
  });

  const [formDataPopup, setFormDataPopup] = useState({
    firstNamePopup: "",
    lastNamePopup: "",
    emailPopup: "",
    mobilePopup: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChangePopup = (e) => {
    const { name, value } = e.target;
    setFormDataPopup({ ...formDataPopup, [name]: value });
  };
   const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const fullPhone = formData.mobile
      ? `${formData.countryCode}${formData.mobile}`
      : null;

    if (window.webengage) {
      window.webengage.onReady(() => {
        window.webengage.user.login(formData.email);

        const userAttributes = {
          we_first_name: formData.firstName,
          we_last_name: formData.lastName,
          we_email: formData.email,
        };

        if (fullPhone) {
          userAttributes.we_phone = fullPhone;
        }

        window.webengage.user.setAttribute(userAttributes);

        const eventData = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
        };

        if (fullPhone) {
          eventData.phone = fullPhone;
        }

        window.webengage.track("LP Form Submitted", eventData);
      });
    }

    setFormData({ firstName: "", lastName: "", email: "" });
    setErrors({ firstName: "", lastName: "", email: "" });

    navigate("/campaign/dubai-properties-v3/thankyou", { state: { formData } });
  };


  const handleSubmitPopup = (e) => {
    e.preventDefault();
    if (!validateFormPopup()) return;

    const fullPhone = formDataPopup.mobilePopup
      ? `${formDataPopup.countryCodePopup}${formDataPopup.mobilePopup}`
      : null;

     const userAttributes = {
          we_first_name: formDataPopup.firstNamePopup,
          we_last_name: formDataPopup.lastNamePopup,
          we_email: formDataPopup.emailPopup,
        };

        if (fullPhone) {
          userAttributes.we_phone = fullPhone;
        }

        window.webengage.user.setAttribute(userAttributes);

        const eventData = {
          firstName: formDataPopup.firstNamePopup,
          lastName: formDataPopup.lastNamePopup,
          email: formDataPopup.emailPopup,
        };

        if (fullPhone) {
          eventData.phone = fullPhone;
        }

    // ✅ Trigger automatic PDF download
    const pdfUrl = `${process.env.PUBLIC_URL}/assets/pdf/Slice_onepager_2.pdf`;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Slice_onepager_2.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // ✅ Reset form
    setFormDataPopup({ firstNamePopup: "", lastNamePopup: "", emailPopup: "", mobilePopup: "" });
    setErrorsPopup({ firstNamePopup: "", lastNamePopup: "", emailPopup: "", mobilePopup: "" });

    // ✅ Navigate after a short delay
    setTimeout(() => {
      navigate("/campaign/dubai-properties-v3/pop-up-thankyou", { state: { formDataPopup } });
    }, 800);
  };


  const swiperRef = useRef(null);
  const handleButtonClick = (slideIndex) => {

    if (swiperRef.current) {
      swiperRef.current?.swiper.slideTo(slideIndex);
    }
  };
  const [activeIndex, setActiveIndex] = useState(0); // first open

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  //popu
  const [showPopup1, setShowPopup1] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);

  useEffect(() => {
    // Show first popup automatically after 90 seconds (90000 ms)
    const timer = setTimeout(() => {
      setShowPopup1(true);
    }, 60000);

    return () => clearTimeout(timer);
  }, []);

  const handleYesClick = () => {
    gtagEvent("V3Popup_Accept");
    setShowPopup1(false); // close first popup
    setShowPopup2(true);  // open second popup
  };

  const handleClose = () => {
    gtagEvent("V3Popup_Reject");
    setShowPopup1(false);
    setShowPopup2(false);
  };
  const promiseCircle = useRef(null);
  const promiseWrap = useRef(null);
  /* The Slice Promise  starts */
  if (window.innerWidth > 990) {
    var i = 1;
    var hovering = false;

    function doSetTimeout() {
      if (hovering === false) {
        setTimeout(() => {
          if (i > 5) {
            i = 1;
            rotateCirc["rotateCirc" + i]();
          } else {
            rotateCirc["rotateCirc" + i]();
          }
          setTimeout(() => {
            doSetTimeout();
          }, 800);
        }, i * 500);
        i++;
      }
    }

    doSetTimeout();

    var promiseNumbers = document.querySelectorAll(".promise-numbers");

    function handleMouseOver(e) {
      hovering = true;
      var x = e.currentTarget.getAttribute("data-id");
      rotateCirc["rotateCirc" + x]();
    }

    for (var j = 0; j < promiseNumbers.length; j++) {
      promiseNumbers[j].addEventListener("mouseover", handleMouseOver);
    }

    var rotateCirc = {
      rotateCirc1: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(0deg)";
          promiseWrap.current.style.background = "rgba(46,255,215,0.15)";
        }
      },

      rotateCirc2: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(72deg)";
          promiseWrap.current.style.background = "rgb(86 253 46 / 40%)";
        }
      },

      rotateCirc3: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(144deg)";
          promiseWrap.current.style.background = "rgb(67 37 245 / 40%)";
        }
      },

      rotateCirc4: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(216deg)";
          promiseWrap.current.style.background = "rgb(255 191 23 / 40%)";
        }
      },

      rotateCirc5: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(288deg)";
          promiseWrap.current.style.background = "rgb(235 112 50 / 40%)";
        }
      },
    };
  }

  useEffect(() => {
    // scroll to #hash on load
    const hash = window.location.hash;
    if (hash) {
      const targetElement = document.getElementById(hash.substring(1));
      if (targetElement) {
        setTimeout(() => {
          const headerOffset =
            document.querySelector("header")?.offsetHeight || 80;
          const elementPosition =
            targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }, 500);
      }
    }
  }, []);
  return (
    <>
      <header id="header" className="sticky">

        <div className="header-box">

          <div className="head-left">


            <div className="logoBox">
              {/* <Link className="logo" href="/" onClick={() => window.scrollTo(0, 0)}>
                                  
                                      <img src={`${REACT_APP_ASSET_URL}/logo.svg`} alt="Logo" />
                                  </Link> */}
              <a href="#Home" onClick={(e) => {
                e.preventDefault();
                callWebengageTrackEvent("Home SLICE Tab clicked");
                handleScroll(e, "Home");
              }}
                className={activeId === "Home" ? "active logo" : "logo"} >     <img src={`${REACT_APP_ASSET_URL}/logo.svg`} alt="Logo" />
              </a>
            </div>
            <div className="startbutSta headbut">

              <Link to="https://webapp.slice.ooo/sign-up" className="curzr-hover change-cursor">
                Sign Up
              </Link>
            </div>
          </div>
          <div className="menu side-menu" onClick={menuClick}>
            <img src={`${REACT_APP_ASSET_URL}/lp/menu-burger.svg`} alt="mobile-menu" />

          </div>
          <ul className="header-list headerCur">

            <li>
              <a
                href="#AboutSLICE"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("About SLICE Tab clicked");
                  handleScroll(e, "AboutSLICE");
                }}
                className={activeId === "AboutSLICE" ? "active" : ""}
              >        About SLICE
              </a>
            </li>
            <li>
              <a
                href="#WhyInvesthere"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Why Invest here? Tab Clicked");
                  handleScroll(e, "WhyInvesthere");
                }}
                className={activeId === "WhyInvesthere" ? "active" : ""}
              >
                Why Invest here?
              </a>
            </li>
            <li>
              <a
                href="#Howitworks"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("How it Works Tab clicked");
                  handleScroll(e, "Howitworks");
                }}
                className={activeId === "Howitworks" ? "active" : ""}
              >
                How it works
              </a>
            </li>
            <li>
              <a
                href="#Returns"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Returns Tab clicked");
                  handleScroll(e, "Returns");
                }}
                className={activeId === "Returns" ? "active" : ""}
              >
                Returns & Security
              </a>
            </li>

            <li>
              <a
                href="#Faqs"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Faqs Tab clicked");
                  handleScroll(e, "Faqs");
                }}
                className={activeId === "Faqs" ? "active" : ""}
              >
                FAQ’s
              </a>
            </li>
            <li className="startbutSta">
              <Link to="https://webapp.slice.ooo/sign-up" className="curzr-hover change-cursor"
               onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3SignUp_Header");
                      setTimeout(() => {
                         window.location.href = "https://webapp.slice.ooo/sign-up";
                      }, 150);
                    }}>
                Sign Up
              </Link>
            </li>

          </ul>

        </div>
        {/* Side Menu */}
        <div className="menuOverlay" />
        <div className="mobile-menu">
          <h3 className="close-menu" onClick={closeClick}>
            <img src={`${REACT_APP_ASSET_URL}/common/cross.svg`} alt="cancel" />
          </h3>
          <ul className="header-list">
            <li>
              <a
                href="#AboutSLICE"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("About SLICE Tab clicked");
                  handleScroll(e, "AboutSLICE");
                }}
                className={activeId === "AboutSLICE" ? "active" : ""}
              >
                About SLICE
              </a>
            </li>
            <li>
              <a
                href="#WhyInvesthere"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Why Invest here? Tab Clicked");
                  handleScroll(e, "WhyInvesthere");
                }}
                className={activeId === "WhyInvesthere" ? "active" : ""}
              >
                Why Invest here?
              </a>
            </li>
            <li>
              <a
                href="#Howitworks"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("How it Works Tab clicked");
                  handleScroll(e, "Howitworks");
                }}
                className={activeId === "Howitworks" ? "active" : ""}
              >
                How it works
              </a>
            </li>
            <li>
              <a
                href="#Returns"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Returns Tab clicked");
                  handleScroll(e, "Returns");
                }}
                className={activeId === "Returns" ? "active" : ""}
              >
                Returns & Security
              </a>
            </li>


            <li>
              <a
                href="#SlicePromise"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Slice Promise Tab clicked");
                  handleScroll(e, "SlicePromise");
                }}
                className={activeId === "SlicePromise" ? "active" : ""}
              >
                Slice Promise
              </a>
            </li>

            <li>
              <a
                href="#Testimonials"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Testimonials Tab clicked");
                  handleScroll(e, "Testimonials");
                }}
                className={activeId === "Testimonials" ? "active" : ""}
              >
                Testimonials
              </a>
            </li>
            <li>
              <a
                href="#Faqs"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Faqs Tab clicked");
                  handleScroll(e, "Faqs");
                }}
                className={activeId === "Faqs" ? "active" : ""}
              >
                FAQ’s
              </a>
            </li>
          </ul>
        </div>



      </header>

      <main className="cursorNo">
        <section id="Home" className="abouSli fracOwner">

          <div className="container">
            <div className="f-row f-3 f-990-1 change-cursor">
              <div className="f-col w50">
                <h1 className="fs-1"><strong> In minutes, not months-</strong> own your share of <strong>Dubai real estate.</strong>
                </h1>
                <p className="fs-4 mbNon"><strong>Frictionless, transparent,</strong> and <strong>fully regulated </strong> access to premium curated properties in Dubai. <strong>Fractional ownership starting from as low as $100</strong>-affordable, secure, and built for the future of investing.</p>

                <div className="f-col cardText d-none">
                  <ul className="d-flex gap-3 startRegul">
                    <li>
                      <img src={`${REACT_APP_ASSET_URL}/lp/start-as-low1.svg`} alt="Start as low as $100" />
                      <h4 className="fs-7">Start as low <br /> as $100</h4>
                    </li>
                    <li>
                      <img src={`${REACT_APP_ASSET_URL}/lp/regulated1.svg`} alt="DFSA Regulated" />
                      <h4 className="fs-7">DFSA <br /> Regulated</h4>
                    </li>
                    <li>
                      <img src={`${REACT_APP_ASSET_URL}/lp/managed1.svg`} alt="Fully Managed" />
                      <h4 className="fs-7">Fully <br /> Managed</h4>
                    </li>
                  </ul>




                </div>
                <Link to="https://webapp.slice.ooo/sign-up" className="butSta btn1"  onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3SignUp1");
                      setTimeout(() => {
                         window.location.href = "https://webapp.slice.ooo/sign-up";
                      }, 150);
                    }}>Sign Up  </Link>

              </div>

              <div id="fractiOwners" className="f-col cardform">
                <div className="get-slice-btns banner-slice-btns">
                  <div className="getSliceBtns">

                    <a href="https://play.google.com/store/apps/details?id=com.slice.com" target="_blank" className="curzr-hover " rel="noopener noreferrer" onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3Google_App");
                      setTimeout(() => {
                        window.open("https://play.google.com/store/apps/details?id=com.slice.com", "_blank");
                      }, 150);
                    }}>
                      <img
                        src={`${REACT_APP_ASSET_URL}/common/slice-google-play.svg`}
                        alt="Slice Google Play"
                      />
                    </a>
                    <a href="https://apps.apple.com/us/app/slice-real-estate-super-app/id6446883858" target="_blank" className="curzr-hover" rel="noopener noreferrer" onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3Apple_App");
                      setTimeout(() => {
                        window.open("https://play.google.com/store/apps/details?id=com.slice.com", "_blank");
                      }, 150);
                    }}>
                      <img
                        src={`${REACT_APP_ASSET_URL}/common/slice-app-store.svg`}
                        alt="Slice App Store"
                      />
                    </a>


                  </div>
                  <img src={`${REACT_APP_ASSET_URL}/lp/signUpMob.png`} alt="mobile App Store" className="mobileMenu" />



                </div>
              </div>

            </div>

          </div>
        </section>

        <section id="AboutSLICE" className="get-slice-box py sliceMak">

          <div className="container">
            <div className="f-row f-2 f-990-1 change-cursor">
              <div className="f-col pe-4">
                <h3 className="fs-1 white">
                  Slice makes real <br />
                  estate investing possible through fractionalisation —
                </h3>
                <p className="fs-4 white">
                  Where investors pool funds to collectively own a property via a Special Purpose Vehicle (SPV). This structure provides legal protection, transparency, and access to opportunities that would otherwise be out of reach for individual investors.
                </p>
              </div>

              <div className="f-col">
                <div className="desktopSlider f-row f-2 f-990-1 change-cursor">
                  {features.map((feature, index) => (
                    <div key={index} className="f-col mb-2">
                      <div className="border-1">
                        <div className="d-flex gap-3 mb-2">
                          <img src={feature.img} alt={feature.title} />
                          <h4 className="fs-3">{feature.title}</h4>
                        </div>
                        <p className="fs-5 white">{feature.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Mobile Slider */}
                <div className="mobileSlider">
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={16}
                    slidesPerView={1}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    loop={true}
                    pagination={{
                      clickable: true,
                      el: '.slider__pagination' // reference custom pagination container
                    }}

                  >
                    {features.map((feature, index) => (
                      <SwiperSlide key={index}>
                        <div className="border-1 p-3">
                          <div className="d-flex gap-3 mb-2">
                            <img src={feature.img} alt={feature.title} />
                            <h4 className="fs-3">{feature.title}</h4>
                          </div>
                          <p className="fs-5 white">{feature.desc}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  {/* Pagination and buttons outside Swiper */}
                  <div className="slider__controls">
                    <div className="slider__pagination"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whatPlatf pb-0">
          <div className="container">
            <div className="f-row ">
              <div className="f-col ">
                <div className="whatBox">
                  <h2 className="fs-2">What is This Platform?</h2>
                  <p className="fs-4"><strong>A frictionless, transparent, and safe platform </strong> that fractionalizes real estate investment.</p>
                  <p className="fs-4">Breaking barriers with affordable entry, curated prime properties, and fully managed structures—so you focus on growth, not complexity.</p>
                  <p className="fs-3"> <img src={`${REACT_APP_ASSET_URL}/lp/ic_arrow2.svg`} alt="people" /> The future of investing-fractional, flexible, and fully managed. <img src={`${REACT_APP_ASSET_URL}/lp/ic_arrow.svg`} alt="people" /></p>
                </div> </div>
            </div>
          </div>
        </section>
        <section id="WhyInvesthere" className="whatPlatf">
          <div className="container">

            <div className="f-row f-1 illusProp">

              <div className="hiw-illus-prop-cube-5">
                <img src={`${REACT_APP_ASSET_URL}/lp/prop.svg`} alt="star" className="mb-2" />
              </div>
              <div className="f-col text-center mb-4">
                <h2 className="fs-2">Why Invest Here?</h2>
                <p className="fs-4 mb-4">A Regulated Gateway to Global Opportunities</p>
              </div>

            </div>


            <div className="f-row f-3 whatPlBx f-990-1 change-cursor">

              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest.svg`} alt="Start Small" className="mb-2" />
                  <h3 className="fs-3">Start Small</h3>
                  <p className="fs-7">Invest in affordable fractional units, beginning from just $100.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest2.svg`} alt="Regulated & Safe" className="mb-2" />
                  <h3 className="fs-3">Regulated & Safe</h3>
                  <p className="fs-7">Licensed under DFSA, based in DIFC.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest3.svg`} alt="Income Potential" className="mb-2" />
                  <h3 className="fs-3">Income Potential</h3>
                  <p className="fs-7">Earn dividends from rental income with potential property appreciation.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest4.svg`} alt="Funds Custody" className="mb-2" />
                  <h3 className="fs-3">Funds Custody</h3>
                  <p className="fs-7">Held securely with Emirates NBD in segregated accounts.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest5.svg`} alt="Easy Entry & Exit" className="mb-2" />
                  <h3 className="fs-3">Easy Entry & Exit</h3>
                  <p className="fs-7">Get access to our marketplace so you can start with small investment amounts and expand over time, with the flexibility to adapt your investments as your goals evolve.</p>
                </div>

              </div>

            </div>
            <div className="f-row f-1">

              <div className="f-col mb-4 text-center">
                <Link to="https://webapp.slice.ooo/sign-up" className="butSta btn1" 
                onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3SignUp2");
                      setTimeout(() => {
                         window.location.href = "https://webapp.slice.ooo/sign-up";
                      }, 150);
                    }}
                >Start Investing Today  </Link>

              </div>

            </div>
          </div>
        </section>

        <section id="Howitworks" className="comm-section">
          <div className="hiw-illus-prop-cube-5">
            <img src={`${REACT_APP_ASSET_URL}/lp/prop1.svg`} alt="star" className="mb-2" />
          </div>
          <div className="hiw-illus-prop-cube-4">
            <img src={`${REACT_APP_ASSET_URL}/lp/ic_star.png`} alt="star" className="mb-2" />
          </div>
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2 mb-2">How It Works</h3>
              <h4 className="fs-8">Investing Made Simple</h4>
            </div>
            <div className="process-wrap">

              <div className="process-right">
                <Swiper
                  ref={swiperRef}
                  slidesPerView={1}
                  speed={800}
                  effect={"fade"}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  modules={[EffectFade, Autoplay]}
                  className="swiper swiperPro swiper-process"
                  onSlideChange={(swiper) => handleSlideChange(swiper)}
                >
                  <SwiperSlide className="swiper-slide">
                    <div className="solutions-media">
                      <img src={`${REACT_APP_ASSET_URL}/lp/mobile.png`} alt="Easy Entry & Exit" className="mb-2" />


                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="solutions-media">
                      <img src={`${REACT_APP_ASSET_URL}/lp/mobile2.png`} alt="Easy Entry & Exit" className="mb-2" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="solutions-media">
                      <img src={`${REACT_APP_ASSET_URL}/lp/mobile3.png`} alt="Easy Entry & Exit" className="mb-2" />
                    </div>
                  </SwiperSlide>



                </Swiper>
              </div>
              <div className="process-left">
                {/* Desktop list */}
                <ul className="solutions-left-wrap comm-slide-list desktopSlider">
                  {steps.map((step, index) => (
                    <li
                      key={index}
                      className={`sol-text st-${index}`}
                      onClick={() => handleButtonClick(index)}
                    >
                      <div className="d-flex d-row gap-3">
                        <img src={step.img} alt={step.title} />
                        <div className="txt-wrap-sol">
                          <h4>{step.title}</h4>
                          <p>{step.desc}</p>
                        </div>
                      </div>
                      <div className="complete-line" />
                    </li>
                  ))}
                </ul>

                {/* Mobile Swiper slider */}
                <div className="mobileSlider">
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={16}
                    slidesPerView={1}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    loop={true}
                    pagination={{
                      clickable: true,
                      el: '.slider_pagination' // reference custom pagination container
                    }}

                  >
                    {steps.map((step, index) => (
                      <SwiperSlide key={index}>
                        <li
                          className={`sol-text st-${index}`}
                          onClick={() => handleButtonClick(index)}
                          style={{ listStyle: "none" }}
                        >
                          <div className="d-flex d-row gap-3">
                            <img src={step.img} alt={step.title} />
                            <div className="txt-wrap-sol">
                              <h4>{step.title}</h4>
                              <p>{step.desc}</p>
                            </div>
                          </div>
                        </li>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="slider__controls">
                    <div className="slider_pagination"></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

        <section id="Returns" className="returSecu">
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2 mb-4">Returns & Security</h3>
              <h4 className="fs-8">Transparent Structures. Potential Returns. Built-in Safeguards.</h4>
            </div>
            <div className="f-row f-2 f-990-1 change-cursor mt-5 returCont">
              <div className="f-col mb-4"> <div className="card internalBanner">
                <h4 className="fs-3">Earnings</h4>
                <ul>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Dividends</h4>
                      <p className="fs-7">From rental income, paid as per agreements.</p>
                    </div>


                  </li>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning1.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Capital Appreciation</h4>
                      <p className="fs-7">Possible gains from value growth.</p>
                    </div>
                  </li>

                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning2.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Valuation Transparency</h4>
                      <p className="fs-7">Independent valuations via dashboard.</p>
                    </div>


                  </li>

                </ul>


              </div>
              </div>
              <div className="f-col mb-4"> <div className="card missionColoured">
                <h4 className="fs-3">Retail Investors</h4>
                <ul>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning3.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">SPV Structure</h4>
                      <p className="fs-7">Each property is ring-fenced.</p>
                    </div>


                  </li>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning4.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Funds Safety</h4>
                      <p className="fs-7">Segregated accounts with Emirates NBD.</p>
                    </div>
                  </li>

                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning5.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Data Protection</h4>
                      <p className="fs-7">Encrypted, with no third-party data sales.</p>
                    </div>


                  </li>

                </ul>


              </div>
              </div>

            </div>
            <div className="commBot">

              <p> <strong> Disclaimer:</strong> Returns not guaranteed. Past performance is not indicative of future results.</p>
            </div>

          </div>
        </section>
        {/* Real Deal Of Real Estate START */}
        <section className="comm-section">
          <div className="container">
            <div className="comm-center-head">
              <h2 className="comm-head-2">Real Deal Of Real Estate </h2>
            </div>
            <div className="section-body table-responsive responPpc">
              <div className="table-wrap active">
                <div className="table-row table-row-1">
                  <div className="table-col table-col-1">
                    <div className="asset-box">
                      <h3 className="comm-head-5">Asset Class</h3>
                      <p className="comm-head-6">
                        Average Annual Return <br />
                        <span className="grey">Based on 20 year CAGR</span>
                      </p>
                    </div>
                  </div>
                  <div className="table-col table-col-2">
                    <div className="table-head">
                      <p className="table-title">Stocks</p>
                      <h2 className="table-data">8.91%</h2>
                    </div>
                    <div className="table-head">
                      <p className="table-title">Bonds</p>
                      <h2 className="table-data">6.02%</h2>
                    </div>
                    <div className="table-head">
                      <p className="table-title">Gold</p>
                      <h2 className="table-data">9.65%</h2>
                    </div>
                  </div>
                </div>
                <div className="table-row table-row-2">
                  <div className="table-col table-col-3">
                    <div className="re-box">
                      <ul className="asset-list">
                        <li>
                          <span className="comm-head-6">Regular cashflow</span>
                        </li>
                        <li>
                          <span className="comm-head-6">
                            Capital Appreciation
                          </span>
                        </li>
                        <li>
                          <span className="comm-head-6">Low Volatility</span>
                        </li>
                        <li>
                          <span className="comm-head-6">Inflation Hedge</span>
                        </li>
                        <li>
                          <span className="comm-head-6">Recession Hedge</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-col table-col-4">
                    <div className="table-body-wrap">
                      <div className="table-body">
                        <ul className="asset-list">
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon text high">High</span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="table-body">
                        <ul className="asset-list">
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon text">Medium</span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="table-body">
                        <ul className="asset-list">
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon text">Medium</span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-row table-row-3">
                  <div className="table-col table-col-5">
                    <div className="table-head">
                      <p className="table-title">Real Estate</p>
                      <h2 className="table-data">11.72%</h2>
                    </div>
                    <div className="table-body">
                      <ul className="asset-list">
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                        <li>
                          <span className="icon text high">High</span>
                        </li>
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="f-col text-center">
              <Link to="https://webapp.slice.ooo/sign-up" className="butSta"  onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3SignUp3");
                      setTimeout(() => {
                         window.location.href = "https://webapp.slice.ooo/sign-up";
                      }, 150);
                    }}>Sign Up </Link>


            </div>
          </div>
        </section>
        {/* Real Deal Of Real Estate END */}

        {/* The Slice Promise */}
        <section className="comm-section promise-sec" id="SlicePromise">
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2">The Slice Promise</h3>
            </div>
            <div className="promise-wrap" ref={promiseWrap}>
              <div className="promise-circle" ref={promiseCircle}>
                <img src={`${REACT_APP_ASSET_URL}/about/circle.png`} alt="" />
              </div>
              <div className="promise-numbers promise-numbers-1" data-id={1}>
                1
                <div className="tooltip">
                  <p>Democratize Real Estate</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-2" data-id={2}>
                2
                <div className="tooltip">
                  <p>Help achieve Real Estate Aspiration for Millions of Users Globally</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-3" data-id={3}>
                3
                <div className="tooltip">
                  <p>Provide simple &amp; transparent transaction</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-4" data-id={4}>
                4
                <div className="tooltip">
                  <p>Deliver best in class ROI</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-5" data-id={5}>
                5
                <div className="tooltip">
                  <p>User experience &amp; user service obsessed</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* The Slice Promise */}

        {/* Happy To SLICE START */}
        <section className="comm-section client-section" id="Testimonials">
          <div className="container">
            <div className="f-row">
              <div className=" w-1200-40 w-990-100">
                <div className="section-header client-header">
                  <h2 className="comm-head-2">Happy To Slice</h2>
                  <p className="comm-body-large">
                    Customers are happily investing with Slice
                  </p>
                </div>
              </div>
              <div className="w70 w-1200-60 w-990-100">
                <Swiper
                  className="client-swiper clientSwiper"
                  effect="coverflow"
                  slidesPerView={1}
                  spaceBetween={0}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  speed={1500}
                  coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    // depth: 450,
                    depth: 200,
                    modifier: 2,
                    slideShadows: false,
                  }}
                  keyboard={{
                    enabled: true,
                  }}
                  breakpoints={{
                    390: { slidesPerView: 1 },
                    480: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    1200: { slidesPerView: 2.7 },
                    1280: { slidesPerView: 3 },
                  }}
                  modules={[Navigation, EffectCoverflow, Autoplay, Controller]}
                  navigation={{
                    prevEl: ".clientSwiperPrev",
                    nextEl: ".clientSwiperNext",
                    clickable: true,
                  }}
                  onSwiper={setFirstClientSwiper}
                  controller={{ control: secondClientSwiper }}>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t2-brooke-anderson_BNK63KLO.jpg`}
                            alt="Brooke Anderson"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t8-vishal-saini_HkzJM6ml.jpg`}
                            alt="Vishal Saini"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t5-james-henderson_ptOiR6mv.jpg`}
                            alt="James Henderson"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t6-rizwan-riaz_fZufQQWa.jpg`}
                            alt="Rizwan Riaz"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t7-stuart-branson_hopo6y8z.jpg`}
                            alt="Stuart Branson"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t10-hal-luscombe_j0r20OcX.jpg`}
                            alt="Hal Luscombe"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t3-camelia-olteanu_CTr7pCSg.jpg`}
                            alt="Camelia Olteanu"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t1-alex-popovici_kvMFtBKU.jpg`}
                            alt="Alex Popovici"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t4-clifford-de-souza_a2RKirVN.jpg`}
                            alt="Clifford de Souza"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t9-zaw-min-htun-1_2EBpQGLK.jpg`}
                            alt="Zaw Min Htun"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>

                <Swiper
                  spaceBetween={25}
                  slidesPerView={1}
                  centeredSlides={true}
                  loop={true}
                  // autoplay={{
                  //   delay: 2000,
                  //   disableOnInteraction: false,
                  // }}
                  className="client-text-swiper clientTextSwiper"
                  breakpoints={{
                    390: { slidesPerView: 1 },
                    480: {
                      slidesPerView: 1,
                    },
                    640: { slidesPerView: 2 },
                    1200: { slidesPerView: 2.7 },
                    1280: { slidesPerView: 3 },
                  }}
                  modules={[Autoplay, Controller]}
                  effect="fade"
                  onSwiper={setSecondClientSwiper}
                  controller={{ control: firstClientSwiper }}>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice real estate app in Dubai is a shining example of
                        transparency and seamlessness. It provides a clear window
                        into the real estate market and offers an incredibly
                        smooth user experience. Investing has never been this
                        straightforward, and I couldn't be happier with Slice!
                      </p>
                      <h2 className="comm-head-5 mb5">Brooke Anderson</h2>
                      <p className="comm-country">New Zealand</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        Slice is a fantastic way to invest in real estate. The app
                        is incredibly easy to use with a very neat and
                        user-friendly interface that makes it simple to find and
                        invest in properties that suit my needs.
                      </p>
                      <h2 className="comm-head-5 mb5">Vishal Saini</h2>
                      <p className="comm-country">India</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        I'm absolutely thrilled with Slice – it's a phenomenal
                        avenue for real estate investment. The app's sheer
                        simplicity, coupled with its impeccably organized and
                        user- friendly interface, effortlessly guides me to
                        discover and invest in properties that perfectly align
                        with my requirements. It's an outstanding experience!
                      </p>
                      <h2 className="comm-head-5 mb5">James Henderson</h2>
                      <p className="comm-country">Republic of South Africa</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        Slice App is perfectly designed keeping all kinds of
                        investors in mind. The concise information and ease of use
                        really make the investment process smooth.
                      </p>
                      <h2 className="comm-head-5 mb5">Rizwan Riaz</h2>
                      <p className="comm-country">Dubai</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        I am thrilled with the Slice real estate app! Its
                        user-friendly interface makes real estate investment a
                        breeze. I can easily choose and invest in property slices,
                        and I'm excited to watch my portfolio grow with Slice.
                        It's a game-changer!
                      </p>
                      <h2 className="comm-head-5 mb5">Stuart Branson</h2>
                      <p className="comm-country">United Kingdom</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice real estate app is the epitome of a
                        frictionless, cool, and seamless experience. It simplifies
                        the complex world of real estate investing and offers an
                        effortless journey from start to finish. If you want an
                        app that combines style with substance, look no further –
                        Slice has it all!
                      </p>
                      <h2 className="comm-head-5 mb5">Hal Luscombe</h2>
                      <p className="comm-country">Republic of South Africa</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice app in Dubai is a real estate revolution. It's
                        thrilling, user-friendly, and effortlessly simplifies
                        property investment in Dubai. Navigating the market is now
                        a breeze, thanks to its unique blend of simplicity and
                        excitement.
                      </p>
                      <h2 className="comm-head-5 mb5">Camelia Olteanu</h2>
                      <p className="comm-country">Luxembourg</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice app has revolutionized my real estate
                        investments. It's incredibly user-friendly, making the
                        entire process seamless. With a few clicks, I explore
                        diverse properties without traditional hassles. Slice
                        simplifies my investment journey, and I couldn't be
                        happier. It's a paradigm shift!
                      </p>
                      <h2 className="comm-head-5 mb5">Alex Popovici</h2>
                      <p className="comm-country">Romania</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        Investing in real estate has always been on my mind,
                        especially in Dubai. With Slice's intuitive app interface,
                        I absolutely love the digital approach it helps me with
                        while letting me pick and choose slices of real estate I
                        want to invest in. Looking forward to growing my portfolio
                        with Slice.
                      </p>
                      <h2 className="comm-head-5 mb5">Clifford de Souza</h2>
                      <p className="comm-country">Dubai</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice app in Dubai is a game-changer for real estate
                        enthusiasts. It's not only user-friendly and cool but also
                        incredibly transparent and educational. It feels like
                        having a mentor in your pocket, providing a fresh
                        perspective on Dubai's real estate scene. I'm thoroughly
                        impressed with the results.
                      </p>
                      <h2 className="comm-head-5 mb5">Zaw Min Htun</h2>
                      <p className="comm-country">Qatar</p>
                    </div>
                  </SwiperSlide>
                </Swiper>

                <div className="client-swiper-btn client-swiper-btn-mob">
                  <div className="swiper-nav swiper-prev clientSwiperPrev">
                    <span className="icon-arrow-left" />
                  </div>
                  <div className="swiper-nav swiper-next clientSwiperNext">
                    <span className="icon-arrow-left" />
                  </div>
                </div>
              </div>
            </div>
            <div className="client-wrapper">
              <div className="box-element">
                <img
                  src={`${REACT_APP_ASSET_URL}/box-elem.svg`}
                  alt=""
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className="stairs-element">
                <img
                  src={`${REACT_APP_ASSET_URL}/stair-elem.svg`}
                  alt=""
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className="star-element">
                <img
                  src={`${REACT_APP_ASSET_URL}/star-elem.svg`}
                  alt=""
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="client-swiper-btn client-swiper-btn-web">
              <div className="swiper-nav swiper-prev clientSwiperPrev">
                <span className="icon-arrow-left" />
              </div>
              <div className="swiper-nav swiper-next clientSwiperNext">
                <span className="icon-arrow-left" />
              </div>
            </div>
            <div className="f-col text-center">
              <Link to="https://webapp.slice.ooo/sign-up" className="butSta"  onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3SignUp4");
                      setTimeout(() => {
                         window.location.href = "https://webapp.slice.ooo/sign-up";
                      }, 150);
                    }}>Sign Up </Link>


            </div>
          </div>
        </section>
        {/* Happy To SLICE END */}
        {/* Partners Starts */}
        <section className="comm-section">
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2">Our Partners</h3>
            </div>
            <div className="f-row f-4 f-768-3 f-480-2">
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/fab.png`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/Emirates_NBD.webp`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/sumsub.png`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/checkout.svg`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/sovereign.png`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/pkf.JPG`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/crowe.jpg`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/wio.png`} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Partners Ends */}
        <section id="Faqs" className="faqComm pt-0">

          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2 mb-2">FAQ’s</h3>
              <h4 className="fs-8">Your Key Questions, Answered</h4>
            </div>
            <div className="space-y-4">
              {faqsQus.map((faq, index) => (
                <div
                  key={index}
                  className={`faq-details ${activeIndex === index ? "active" : ""
                    }`}
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="comm-head-4">
                    {faq.question}
                    <span>{activeIndex === index ? "−" : "+"}</span>
                  </h3>
                  {activeIndex === index && (
                    <p className="faq-ans comm-body faq-answer">{faq.answer}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="comm-section  get-slice-box dubaiReal sliceMak">
          <div className="container">
            <div className="comm-center-head ">
              <h3 className="comm-head-2 white">Start Your Journey in Dubai Real Estate</h3>

            </div>


            <div className="f-row f-1 ">
              <div className="f-col mb-4">

                <ul className="d-flex gap-3  my-auto">
                  <li className="fs-8">No joining fee</li>
                  <li className="fs-8">DFSA Regulated</li>
                  <li className="fs-8">Accessible from $100</li>
                </ul>

              </div>
              <div className="f-col text-center">
                <Link to="https://webapp.slice.ooo/sign-up" className="butSta btn2"  onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V3SignUp5");
                      setTimeout(() => {
                         window.location.href = "https://webapp.slice.ooo/sign-up";
                      }, 150);
                    }}>Sign Up Now</Link>


              </div>

            </div>

          </div>
        </section>



      </main>

      <footer className="footer-wrap change-cursor">
        <div className="container change-cursor">
          <div className="footer-box change-cursor">
            <div className="footer-top change-cursor">
              <div className="f-row change-cursor flex-center">
                <div className="w80 w-768-100 footer-logo-wrap change-cursor text-center">
                  <div className="logo footer-logo change-curso ">
                    <img src={`${REACT_APP_ASSET_URL}/slice-logo-white.svg`} alt="Logo" />
                  </div>

                  <p className="footer-txt change-cursor">This platform is incorporated in the Dubai International Financial Centre (DIFC) and regulated by the Dubai Financial Services Authority (DFSA). Investments are made via Special Purpose Vehicles (SPVs). Investing in real estate carries risk. Returns are not guaranteed, and investors may lose part or all of their capital. Past performance is not a reliable indicator of future results.</p>
                </div>

              </div>
            </div>

            <div className="footer-bottom change-cursor text-center d-column">
              <div className="footer-list social-list change-cursor mb-4">
                <ul className=" change-cursor">
                  <li className=" change-cursor">
                    <a href="https://www.instagram.com/slicesuperapp/" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <img src={`${REACT_APP_ASSET_URL}/common/insta.svg`} alt="" width="100%" height="100%" loading="lazy" className="curzr-hover "></img>
                    </a>
                  </li>
                  <li className=" change-cursor">
                    <a href="https://www.facebook.com/SliceSuperApp" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <i className="icon-facebook change-cursor" />
                    </a>
                  </li>
                  <li className=" change-cursor">
                    <a href="https://twitter.com/Slicesuperapp" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <img src={`${REACT_APP_ASSET_URL}/common/twitter.svg`} alt="" width="100%" height="100%" loading="lazy" className="curzr-hover "></img>
                      {/* <i className="icon-twitter change-cursor" /> */}
                    </a>
                  </li>
                  <li className=" change-cursor">
                    <a href="https://www.linkedin.com/company/slice-fintech/" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <img src={`${REACT_APP_ASSET_URL}/linkedin-logo.svg`} alt="" width="100%" height="100%" loading="lazy" className="curzr-hover linedin-img"></img>
                      {/* <i className="icon-twitter change-cursor" /> */}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="terms-pages change-cursor termsPages">
                <Link to="/faq?data=RiskDisclosures" target="_blank" className="curzr-hover change-cursor" onClick={() => handleLinkClick()}>
                  Key Risk
                </Link>
                <Link to="/terms-condition" target="_blank" className="curzr-hover change-cursor" onClick={() => handleLinkClick()}>
                  Terms & Conditions
                </Link>
                <Link to="/privacy-policy" target="_blank" className="curzr-hover change-cursor" onClick={() => handleLinkClick()}>
                  Privacy Policy
                </Link>
              </div>
              <p className="footer-txt change-cursor w100 ">{(new Date().getFullYear())} Slice. All rights reserved.</p>

            </div>
          </div>
        </div>
      </footer>
      {/* Popup 1 */}
      {showPopup1 && (
        <div className="popupShow">
          <div className="popupShRow">
            {/* <a
              href="javascript:void(0)"
              className="close"
              onClick={handleClose}
            >
              x
            </a> */}
            <h2 className="fs-2">
              Discover How Dubai Property Creates Real Wealth
            </h2>
            <p className="fs-5">
              Unlock your free expert guide explaining how Dubai property has
              historically offered strong yields and capital appreciation,
              supported by investor-friendly regulations.
            </p>
            <button className="butYes but2" onClick={handleYesClick}>
              Yes, I Want the Free Guide!
            </button>
            <button className="butNo" onClick={handleClose}>
              No, I’ll Stay Curious for Now
            </button>
          </div>
        </div>
      )}

      {/* Popup 2 */}
      {showPopup2 && (
        <div className="popupShow">
          <div className="popupShRow ">
            <a
              href="javascript:void(0)"
              className="close"
              onClick={handleClose}
            >   x   </a>
            <h2 className="fs-4">Fill out the form to instantly download Slice’s exclusive investor guide.</h2>
            <div className="card">
              <form onSubmit={handleSubmitPopup} className="formBox">
                <div className="mb-4">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="firstNamePopup"
                    placeholder="First Name"
                    value={formDataPopup.firstNamePopup}
                    onChange={handleChangePopup}
                    className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                  />
                  {popuperrors.firstNamePopup && (
                    <p className="text-red-500 text-sm">{popuperrors.firstNamePopup}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastNamePopup"
                    placeholder="Last Name"
                    value={formDataPopup.lastNamePopup}
                    onChange={handleChangePopup}
                    className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                  />
                  {popuperrors.lastNamePopup && (
                    <p className="text-red-500 text-sm">{popuperrors.lastNamePopup}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="emailPopup"
                    placeholder="Email Address"
                    value={formDataPopup.emailPopup}
                    onChange={handleChangePopup}
                    className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                  />
                  {popuperrors.emailPopup && (
                    <p className="text-red-500 text-sm">{popuperrors.emailPopup}</p>
                  )}
                </div>

                 <div className="mb-4">
                  <label>Mobile (Optional)</label>

                  <div className="flex gap-2 countryCode">
                    {/* Country Code Select */}
                    <select
                      value={formDataPopup.countryCodePopup || ""}
                      onChange={handleCountryChange}
                      className="p-3 rounded bg-gray-800 border border-gray-700 text-white w-40"
                      name="countryCodePopup"
                    >
                      {countryCodes.map(c => (
                        <option key={c.phone} value={c.phone}>
                          {getFlag(c.code)} {c.phone}
                        </option>
                      ))}
                    </select>

                    {/* Phone Number Input */}
                    <input
                      type="tel"
                      name="mobilePopup"
                      placeholder="Mobile Number"
                      value={formDataPopup.mobilePopup}
                      onChange={handleChangePopup}
                      className="p-3 rounded bg-gray-800 border border-gray-700 text-white flex-1"
                    />
                  </div>

                  {popuperrors.mobilePopup && (
                    <p className="text-red-500 text-sm">{popuperrors.mobilePopup}</p>
                  )}
                </div>

                <div className="mb-4">
                  <button className="but2 butDownl">Download Free Guide Now</button>
                </div>
                <div className="labelLock">
                  <label>Your information is secure. We never share your data.</label>
                </div>
              </form>




            </div>

          </div>
        </div>
      )}


      {!isMobile && (
        // <div className="curzr">
        //   <div className="curzr-dot"></div>
        // </div>
        <AnimatedCursor
          innerSize={0}
          outerSize={25}
          innerScale={1}
          outerScale={1.7}
          outerAlpha={0}
          trailingSpeed={1}
          // hasBlendMode={true}
          // innerStyle={{
          //   border: "2px solid #f00",
          // }}
          outerStyle={{
            border: "2px solid rgba(67, 37, 245, 1)",
            background: "rgba(67, 37, 245, 0.5)",
            // border: "2px solid rgba(46, 255, 215, 1)",
            // background: "rgba(46, 255, 215, 0.15)",
            // border: "2px solid rgba(86, 252, 46, 1)",
            // background: "rgba(86, 252, 46, 0.15)",
            mixBlendMode: "difference",
          }}
        />
      )}
    </>
  );
};

export default LPv3;
